<ch-breadcrumb [parts]="['Dashboard']"></ch-breadcrumb>

<div class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">
      Filters <button id='dashboardClearAll' type="button" (click)="clearFilters()" class="btn btn-default pull-right">Clear all</button>
    </h3>
  </div>
  <div class="panel-body">
    <div class="table-nav-menu">
      <ch-live-search
        [items]="locations"
        [showClass]="1"
        (change)="locationChanged($event)"
        value="{{ pageParams.locationId }}"
      ></ch-live-search>
      <ch-daterangepicker (selected)="datepickerChanged($event)" [data]="pageParams" pastSearch="true" id="dashboard-period-picker"></ch-daterangepicker>
    </div>
  </div>
</div>

<div class="panel panel-default">
  <div class="panel-heading"><h3 class="panel-title"></h3></div>
  <div class="panel-body">
    <div class="loading-cont" *ngIf="statsLoading"><div class="loading-spinner"></div></div>
    <div *ngIf="!statsLoading">
      <div class="col-sm-12 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center" style="background: #67053d;">
            <a class="text-white" style="text-decoration: none;">
              <div class="text-uppercase font-weight-bold">TEMPORARY DISABLED</div>
            </a>
          </div>
        </div>
      </div>


      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ globalStats.liveUsers }}</div>
              <div class="text-uppercase font-weight-bold">Live Users</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ globalStats.activeUsers }}</div>
              <div class="text-uppercase font-weight-bold">Active Users</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ globalStats.offerViews }}</div>
              <div class="text-uppercase font-weight-bold">Page Views</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ globalStats.offerRedemptions }}</div>
              <div class="text-uppercase font-weight-bold">Redemptions</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">Members (Total: {{ memberStats.total }})</h3>
  </div>
  <div class="panel-body">
    <div class="loading-cont" *ngIf="memberStatsLoading"><div class="loading-spinner"></div></div>
    <div *ngIf="!memberStatsLoading">
      <div class="col-sm-12 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center" style="background: #67053d;">
            <a class="text-white" style="text-decoration: none;">
              <div class="text-uppercase font-weight-bold">TEMPORARY DISABLED</div>
            </a>
          </div>
        </div>
      </div>


      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ memberStats.registered }}</div>
              <div class="text-uppercase font-weight-bold">Registered</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;" (click)="filterMembersWithStatus('APPROVED')">
              <div class="display-4 font-weight-bold">{{ memberStats.approved }}</div>
              <div class="text-uppercase font-weight-bold">Approved</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;" (click)="filterMembersWithStatus('REJECTED')">
              <div class="display-4 font-weight-bold">{{ memberStats.rejected }}</div>
              <div class="text-uppercase font-weight-bold">Rejected</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ memberStats.freeTrialSubscribers }}</div>
              <div class="text-uppercase font-weight-bold">Trial</div>
            </a>
          </div>
        </div>
      </div>

      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ memberStats.firstTimeSubscribers }}</div>
              <div class="text-uppercase font-weight-bold">1st Subs</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ memberStats.renewals }}</div>
              <div class="text-uppercase font-weight-bold">Renewals</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ memberStats.nonRenewals }}</div>
              <div class="text-uppercase font-weight-bold">Non Renewals</div>
            </a>
          </div>
        </div>
      </div>

      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ memberStats.vip }}</div>
              <div class="text-uppercase font-weight-bold">VIP</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-4 font-weight-bold">{{ memberStats.freeSubscribers }}</div>
              <div class="text-uppercase font-weight-bold">Free Subscription</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a
              class="text-white"
              (click)="statClick()"
              style="text-decoration: none;"
              (click)="filterMembersWithStatus('WAITING_FOR_APPROVAL')"
            >
              <div class="display-4 font-weight-bold">{{ memberStats.waitingForApproval }}</div>
              <div class="text-uppercase font-weight-bold">Waiting For Approval</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a
              class="text-white"
              (click)="statClick()"
              style="text-decoration: none;"
              (click)="filterMembersWithStatus('WAITING_FOR_PROOF')"
            >
              <div class="display-4 font-weight-bold">{{ memberStats.waitingForProof }}</div>
              <div class="text-uppercase font-weight-bold">Waiting for Proof</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-2 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;" (click)="filterMembersWithStatus('SUSPENDED')">
              <div class="display-4 font-weight-bold">{{ memberStats.suspended }}</div>
              <div class="text-uppercase font-weight-bold">Suspended</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="panel panel-default">
  <div class="panel-heading"><h3 class="panel-title">Conversion stats</h3></div>
  <div class="panel-body">
    <div class="loading-cont" *ngIf="conversionStatsLoading"><div class="loading-spinner"></div></div>
    <div *ngIf="!conversionStatsLoading">
      <div class="col-sm-12 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center" style="background: #67053d;">
            <a class="text-white" style="text-decoration: none;">
              <div class="text-uppercase font-weight-bold">TEMPORARY DISABLED</div>
            </a>
          </div>
        </div>
      </div>


      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-6 font-weight-bold">{{ getConversionLabel('approved') }}</div>
              <div class="text-uppercase font-weight-bold">Approved Users</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-6 font-weight-bold">{{ getConversionLabel('freeTrial') }}</div>
              <div class="text-uppercase font-weight-bold">Free Trial Users</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-6 font-weight-bold">{{ getConversionLabel('paidSubscribers') }}</div>
              <div class="text-uppercase font-weight-bold">Paid Subscription</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-6 font-weight-bold">{{ getConversionLabel('renewals') }}</div>
              <div class="text-uppercase font-weight-bold">Renewal</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">
      Retention rates
      <button
        type="button"
        (click)="changeRetentionFilter('LIVE')"
        [ngClass]="{ active: isLiveRetention }"
        class="btn btn-danger pull-right"
      >
        Live
      </button>
      <button
        type="button"
        (click)="changeRetentionFilter('ACTIVE')"
        [ngClass]="{ active: isActiveRetention }"
        class="btn btn-default pull-right"
      >
        Active
      </button>
    </h3>
  </div>
  <div class="panel-body">
    <div class="loading-cont" *ngIf="retentionStatsLoading"><div class="loading-spinner"></div></div>
    <div *ngIf="!retentionStatsLoading">
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-6 font-weight-bold">{{ getRetentionStatLabel('lastWeek') }}</div>
              <div class="text-uppercase font-weight-bold">Past Week</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-6 font-weight-bold">{{ getRetentionStatLabel('lastMonth') }}</div>
              <div class="text-uppercase font-weight-bold">Past Month</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-6 font-weight-bold">{{ getRetentionStatLabel('lastQuarter') }}</div>
              <div class="text-uppercase font-weight-bold">Past Quarter</div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-sm-3 card-small">
        <div class="card card-inverse card-important bg-primary">
          <div class="card-body text-center">
            <a class="text-white" (click)="statClick()" style="text-decoration: none;">
              <div class="display-6 font-weight-bold">{{ getRetentionStatLabel('lastYear') }}</div>
              <div class="text-uppercase font-weight-bold">Past Year</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header">
    Offers
    <button type="button" (click)="changeOfferSort('EXPIRY')" [ngClass]="{ active: isExpiryOfferSort }" class="btn btn-default pull-right">
      Expiring
    </button>
    <button type="button" (click)="changeOfferSort('WORST')" [ngClass]="{ active: isWorstOfferSort }" class="btn btn-default pull-right">
      Worst
    </button>
    <button type="button" (click)="changeOfferSort('TOP')" [ngClass]="{ active: isTopOfferSort }" class="btn btn-danger pull-right">
      Top
    </button>
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="topOffersLoading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!topOffersLoading && 0 === topOffers.length">No offers found.</p>

      <table class="table table-hover" *ngIf="!topOffersLoading && 0 < topOffers.length">
        <thead>
          <tr>
            <th><span class="col-name">#</span></th>
            <th><span class="col-name">Offer Name</span></th>
            <th><span class="col-name">Workplace</span></th>
            <th><span class="col-name">Expiry Date</span></th>
            <th><span class="col-name">Redemptions</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of topOffers; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.headline }}</td>
            <td>{{ item.establishmentName }}</td>
            <td>{{ (item.endDate | dateFormat) || '-' }}</td>
            <td>{{ item.redemptionsCount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header">Top users</div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="topUsersLoading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!topUsersLoading && 0 === topUsers.length">No users found.</p>

      <table class="table table-hover" *ngIf="!topUsersLoading && 0 < topUsers.length">
        <thead>
          <tr>
            <th><span class="col-name">#</span></th>
            <th><span class="col-name">Name</span></th>
            <th><span class="col-name">Workplace</span></th>
            <th><span class="col-name">Redemptions</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of topUsers; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.firstName + ' ' + item.lastName }}</td>
            <td>{{ item.employer }}</td>
            <td>{{ item.redemptionsCount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/dashboard/dashboard/dashboard.component.html